import React from 'react';
var useBoolean = function (initialState) {
    var _a = React.useState(initialState), state = _a[0], setState = _a[1];
    var setTrue = React.useCallback(function () { return setState(true); }, []);
    var setFalse = React.useCallback(function () { return setState(false); }, []);
    var toggle = React.useCallback(function () { return setState(!state); }, [state]);
    return [state, setTrue, setFalse, toggle];
};
export default useBoolean;
